import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { setGeneralRemarks } from '../../../actions/common';

import generalRemarkTypes from '../../helpers/generalRemarkTypes';
import Remarks from './Remarks';

const GeneralRemarks = ({ channel, resultId, setRemarks, value, type, onConfirm }) => (
  <Remarks
    remarkTypes={generalRemarkTypes(channel)}
    resultId={resultId}
    setRemarks={setRemarks}
    value={value}
    selectedType={type}
    onConfirm={onConfirm}
  />
);

GeneralRemarks.defaultProps = {
  value: null,
  type: null,
};

GeneralRemarks.propTypes = {
  channel: PropTypes.string.isRequired,
  resultId: PropTypes.string.isRequired,
  setRemarks: PropTypes.func.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  value:
    state.common.generalRemarks[ownProps.resultId] &&
    state.common.generalRemarks[ownProps.resultId].content,
  type:
    state.common.generalRemarks[ownProps.resultId] &&
    state.common.generalRemarks[ownProps.resultId].type,
});

const mapDispatchToProps = dispatch => ({
  setRemarks: (type, remarks, resultId, callbackParams) =>
    dispatch(setGeneralRemarks(type, remarks, resultId, callbackParams)),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GeneralRemarks));
